<template>
    <div class="employee-tab-inner">        
        <!--<ul class="list-group mb-3 " v-if='errormsg'>           
            <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
        </ul>-->     
        <b-overlay :show="showoverlay" rounded="sm">
             <div class="">
                <b-tabs tab-class="nav-item-trustee" content-class="mt-4" nav-wrapper-class="trustee-nav-wrapper mt-4">
                    <template v-slot:tabs-start>
                        <b-nav-item disabled href="#" class="trustee-nav-first-wrapper">
                            <div class="trustee-nav-first">
                                <div class="trustee-nav-head">Provident Fund Advance Management</div>
                                <div class="trustee-nav-subhead">Provident Fund Advance Applications and Disbursements.</div>
                            </div>
                        </b-nav-item>
                    </template> 
                    <b-tab lazy active title-item-class="trustee-nav wi-two">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">Advance Applications</div>
                                </div>
                                <div class="trustee-report-intro">
                                    View all Advance Applications.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-loan-applications :pageurl="this.$api_url"  :key="this.init_flg" :flg="this.init_flg" :is_trustee="this.is_trustee"></pf-loan-applications>
                            </div>
                        
                    </b-tab> 
                    <b-tab lazy title-item-class="trustee-nav">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">Advances Awaiting Disbursement</div>
                                </div>
                                <div class="trustee-report-intro">
                                    View all Advances awaiting Disbursement.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-loan-applications-disbursement :pageurl="this.$api_url"  :key="this.init_flg" :flg="this.init_flg" :is_trustee="this.is_trustee"></pf-loan-applications-disbursement>
                            </div>
                        
                    </b-tab> 
                    
                    <!-- Form ends here -->
                </b-tabs>
            </div>
        </b-overlay>

    </div>
    
    
    
    
</template>
 
<script>
    
    import moment from 'moment';
    export default{
        
        mounted() {
            
            this.showoverlay = false;
        },
        props: ['pageurl' , 'flg'],

        data(){            
            
            return {
            
                showoverlay : true,
                errormsg:[],
                init_flg : 0,
                is_trustee:1,
            }
        },
        methods:{
            updateTransactions(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/pf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.init_flg = this.init_flg + 1;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
        },
        created: function(){
            if(!this.checkNet()) return false;
            this.$validator.reset();
            this.updateTransactions(1);
        }
    }
</script>


